import React, { useState } from "react";
import styles from "./GiftItem.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import getImageUrl from "helpers/getImageUrl";
// import IsAvailable from "assets/SVG/IsAvailable";

const getGiftImage = (prod) => {
  if (!prod) return null;
  return prod?.image ?? prod?.images_source ?? prod?.thumbnail_image_source ?? prod?.thum_img
    ?? prod?.gallary_images_api?.[0]?.images_source ?? prod?.product?.thumbnail_image_source
    ?? prod?.product?.gallary_images_api?.[0]?.images_source ?? (typeof prod === "string" ? prod : null);
};

const getGiftProductId = (prod) =>
  prod?.product_id ?? prod?.id ?? prod?.seller_product_id ?? prod?.seller_id
    ?? prod?.product?.id ?? prod?.product?.seller_product_id;

const getGiftProductName = (prod) =>
  prod?.product_name ?? prod?.name ?? prod?.product?.product_name ?? prod?.product?.name ?? "";

const GiftItem = ({ handlerChooseGift, prod, breadcrumbs = [], activeGiftId, setActiveGiftId }) => {
  const { currentLanguage } = useSelector(({ main }) => main);
  const giftImg = getGiftImage(prod);
  const giftId = getGiftProductId(prod);
  const giftName = getGiftProductName(prod);

  if (breadcrumbs?.length > 0 && breadcrumbs?.[0]?.slug === 'furniture') {
    const handleClick = (id) => {
      setActiveGiftId(id);
      handlerChooseGift(id);
    };
    const itemStyles = activeGiftId === giftId ? styles.activeGift : "";
    return (
      <div
        className={`${styles.GiftItem} ${itemStyles}`}
        onClick={() => handleClick(giftId)}
      >
        <img
          src={getImageUrl(giftImg) || require("../../../../assets/defaultImg.png")}
          alt=""
          className={styles.GiftImage}
        />
        <p className={styles.GiftText}>{giftName}</p>
      </div>
    );
  }

  return (
    <Link
      to={`${currentLanguage !== "hy" ? "/" + currentLanguage : ""}/Product/${giftId}`}
      className={styles.GiftItem}
    >
      <img
        src={getImageUrl(giftImg) || require("../../../../assets/defaultImg.png")}
        alt=""
        className={styles.GiftImage}
      />
      <p className={styles.GiftText}>{giftName}</p>
    </Link>
  );
};

export { GiftItem };
